import { type AccountForChildEligibilityDetails, IneligibilityReasonCode, ProcessStatus } from '@generated-types';
import type { ProcessId } from '@types';
import type { ChildWithExistingAccount, ChildWithExistingProcess } from '@/types/child-types';

export const getExistingProcessId = ({
    currentBankCreateShareSavingsAccountEligibility,
}: ChildWithExistingProcess): ProcessId =>
    currentBankCreateShareSavingsAccountEligibility.ineligibilityReason.existingProcess.processId;

const hasExistingProcessId = (childEligibility: AccountForChildEligibilityDetails) =>
    typeof childEligibility.currentBankCreateShareSavingsAccountEligibility.ineligibilityReason?.existingProcess
        ?.processId === 'string';

export const hasExistingProcessInCurrentBank = (
    childEligibility: AccountForChildEligibilityDetails,
): childEligibility is ChildWithExistingProcess => hasExistingProcessId(childEligibility);

const getExistingProcessStatus = ({
    currentBankCreateShareSavingsAccountEligibility,
}: ChildWithExistingProcess): ProcessStatus =>
    currentBankCreateShareSavingsAccountEligibility.ineligibilityReason.existingProcess.status;

export const alreadyHasAccount = (
    childEligibility: AccountForChildEligibilityDetails,
): childEligibility is ChildWithExistingAccount =>
    childEligibility.currentBankCreateShareSavingsAccountEligibility.ineligibilityReason?.reasonCode ===
    IneligibilityReasonCode.ACCOUNT_ALREADY_EXISTS;

export const waitingForApproverParentConsent = (eligibility: ChildWithExistingProcess) =>
    getExistingProcessStatus(eligibility) === ProcessStatus.WAITING_FOR_APPROVER_PARENT_CONSENT;

export const hasNotCompletedKYCForm = (eligibility: ChildWithExistingProcess) =>
    getExistingProcessStatus(eligibility) === ProcessStatus.PENDING_KYC_CONSENT;

export const hasPendingKYCAdvisorReview = (eligibility: ChildWithExistingProcess) =>
    getExistingProcessStatus(eligibility) === ProcessStatus.PENDING_KYC_ADVISOR_REVIEW;
